class WishlistRemoveFavourite extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.removeItem = this.removeItem.bind(this)
    this.listeners.add(this, 'click', this.removeItem)
  }

  async removeItem (e) {
    e.preventDefault()

    window.BAO.wishlist.genericModalHeading = this.modalHeading
    window.BAO.wishlist.genericModalText = this.modalText
    window.BAO.wishlist.genericModalCancelText = this.modalCancelText
    window.BAO.wishlist.genericModalContinueText = this.modalContinueText
    window.BAO.wishlist.openGenericModal()

    window.BAO.wishlist.genericModalContinue = async () => {
      // data-item-id carries the wishlist_favourite metaobject handle —
      // the remove key on the new proxy (#145); no Bearer token (ADR-0005)
      await window.BAO.wishlist.removeFavourite(this.itemId)

      window.location.reload()
    }
  }

  get itemId () {
    return this.dataset.itemId
  }

  get modalHeading () {
    return this.dataset.modalHeading
  }

  get modalText () {
    return this.dataset.modalText
  }

  get modalCancelText () {
    return this.dataset.modalCancelText
  }

  get modalContinueText () {
    return this.dataset.modalContinueText
  }
}

customElements.define('wishlist-remove-favourite', WishlistRemoveFavourite)
